import { render, staticRenderFns } from "./ProtocolloListComponent.vue?vue&type=template&id=77580792"
import script from "./ProtocolloListComponent.vue?vue&type=script&lang=js"
export * from "./ProtocolloListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports